import React from 'react';
import './AdminStatCard.css';

const AdminTable = ({ title, columns, data, renderRow, emptyMessage = "Sin datos" }) => {
  return (
    <div className="ad-card ad-leaderboard-section" style={{ height: '100%' }}>
      <h2>{title}</h2>
      <div className="ad-table-wrapper">
        <table className="ad-table">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item, idx) => renderRow(item, idx))
            ) : (
              <tr>
                <td colSpan={columns.length} className="ad-empty">
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminTable;